require('./jointHolderStatusCard.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
import { FormattedText } from 'core/i18n';
// @ utilities
const ClientIcon = require('assets/icons/headline/hazte_cliente.svg');
const creditCardIcon = require('assets/icons/headline/icono_tarjeta2.svg');
const classNames = require('classnames');

class JointHolderStatusCard extends React.Component {
    constructor(props) {
        super(props);
        this.getType = this.getType.bind(this);
        this.getStatus = this.getStatus.bind(this);
    }

    getType(holderType) {
        const type = {
            titular: 'jointHolderAccountType-titular',
            cotitular: 'jointHolderAccountType-jointHolder',
            autorizado: 'jointHolderAccountType-authorized',
        };

        return type[holderType];
    }

    getStatus(holderStatus, batchStatus) {
        let statusValue;
        let colorClass;

        if (batchStatus) {
            statusValue = 'jointHolderStatus-batchStatus';
        } else {
            switch (holderStatus) {
                case 'invite sent':
                    statusValue = 'jointHolderStatus-pendingInvite';
                    colorClass = 'action';
                    break;
                case 'waiting':
                case 'ready':
                    statusValue = 'jointHolderStatus-completed';
                    colorClass = 'pending';
                    break;
                case 'batch':
                    statusValue = 'jointHolderStatus-batchStatus';
                    colorClass = 'warning';
                    break;
                case 'created':
                case 'identification':
                case 'identified':
                case 'contract':
                case 'signed':
                case 'documentation':
                    statusValue = 'jointHolderStatus-inProcess';
                    colorClass = 'pending';
                    break;
                case 'documented':
                case 'standby':
                    statusValue = 'jointHolderStatus-processCompleted';
                    colorClass = 'success';
                    break;
                case 'register':
                case 'additional':
                case 'fioc':
                default:
                    statusValue = 'jointHolderStatus-pendingCompleteData';
                    colorClass = 'pending';
            }
        }

        const triangleClass = classNames(
            'card-box__status-box__tag-triangle',
            `card-box__status-box__tag-triangle--${colorClass}`
        );
        const textClass = classNames('card-box__status-box__tag-text', `card-box__status-box__tag-text--${colorClass}`);

        return (
            <div className={'card-box__status-box__tag-container'}>
                <div className={triangleClass} />
                <div className={textClass}>
                    <FormattedText value={statusValue} />
                </div>
            </div>
        );
    }

    getDetails() {
        const { immJointHolder, batchStatus } = this.props;
        const status = immJointHolder.get('status');
        const expiration = immJointHolder.get('expiration');
        let detailStatus = null;

        if (!batchStatus && status === 'invite sent') {
            detailStatus = <FormattedText value={'jointHolderStatus-invite'} injectedStrings={[expiration]} />;
        }

        return detailStatus;
    }

    getName() {
        const { immJointHolder } = this.props;
        const name = immJointHolder.get('name');
        let correctName;

        if (name.includes('1')) {
            correctName = <FormattedText value="jointHolderStatus-firstJointHolder" />;
        } else if (name.includes('2')) {
            correctName = <FormattedText value="jointHolderStatus-secondJointHolder" />;
        } else if (name.includes('3')) {
            correctName = <FormattedText value="jointHolderStatus-thirdJointHolder" />;
        } else if (name.includes('4')) {
            correctName = <FormattedText value="jointHolderStatus-fourthJointHolder" />;
        } else {
            correctName = name;
        }

        return correctName;
    }

    getOpenCredit() {
        const { immJointHolder } = this.props;

        return immJointHolder.get('checkOpenCredit') ? (
            <img src={creditCardIcon} alt="" className="card-box__check-open-credit" />
        ) : (
            ''
        );
    }

    render() {
        const { immJointHolder, batchStatus } = this.props;
        const details = this.getDetails();
        const name = this.getName();
        const status = this.getStatus(immJointHolder.get('status'), batchStatus);
        const type = this.getType(immJointHolder.get('type'));
        const checkOpenCredit = this.getOpenCredit();

        return (
            <div className="row">
                <div className="card-box clearfix">
                    <div className="col-sm-6">
                        <div className="card-box__icon">
                            <img src={ClientIcon} alt="" />
                        </div>
                        <div className="card-box__name-box">
                            <div className="card-box__name-box__name">{name}</div>
                            <div className="card-box__name-box__type">
                                <FormattedText value={type} />
                                {checkOpenCredit}
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card-box__status-box">
                            {status}
                            <div className="card-box__status-box__details">{details}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

JointHolderStatusCard.propTypes = {
    immJointHolder: PropTypes.object.isRequired,
};

module.exports = JointHolderStatusCard;
